import { ApplicationConfig, CSP_NONCE, InjectionToken, isDevMode } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslate } from './translations.provider';
import { AppConfigInterface } from './config/app.config.interface';
import { productionConfig } from './config/app.production.config';
import { devserverConfig } from './config/app.devserver.config';
import { testConfig } from './config/app.test.config';
import { uatConfig } from './config/app.uat.config';
import { stageConfig } from './config/app.stage.config';
import { environment } from './environments/environment';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routes } from './app.routes';
import { CookieService } from 'ngx-cookie-service';
import { provideKeycloakAngular } from './keycloak.config';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import '@angular/common/locales/global/fr';

import { UserService } from './shared/services/user.service';
import { UserMockService } from './shared/services/user.mock.service';
import { CaseService } from './shared/services/case.service';
import { CaseMockService } from './shared/services/case.mock.service';
import { DictionaryService } from './shared/services/dictionary.service';
import { DictionaryMockService } from './shared/services/dictionary.mock.service';
import { FormService } from './shared/services/form.service';
import { FormMockService } from './shared/services/form.mock.service';
import { PaymentsService } from './shared/services/payments.service';
import { PaymentsMockService } from './shared/services/payments.mock.service';
import { serviceTechnicalBreakInterceptor } from './interceptors/technical-break.interceptor';
import { devConfig } from './config/app.dev.config';

export const APP_CONFIG = new InjectionToken('app.config');
export let LOGO_FILE: File;

export const AppConfig: AppConfigInterface = getConfig();

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withFetch(),
      withInterceptors([includeBearerTokenInterceptor, serviceTechnicalBreakInterceptor]),
      withXsrfConfiguration({
        cookieName: 'CUSTOM_XSRF_TOKEN',
        headerName: 'X-XSRF-TOKEN',
      })
    ),
    provideAnimations(),
    provideRouter(routes),
    provideTranslate(),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideKeycloakAngular(AppConfig),
    provideClientHydration(withIncrementalHydration()),
    { provide: APP_CONFIG, useValue: AppConfig },
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
    // {
    //   provide: CSP_NONCE,
    //   useValue: 'NGINX_CSP_NONCE'
    // },
    // { provide: UserService, useClass: UserMockService },
    // { provide: CaseService, useClass: CaseMockService },
    // { provide: DictionaryService, useClass: DictionaryMockService },
    // { provide: FormService, useClass: FormMockService },
    // { provide: PaymentsService, useClass: PaymentsMockService },
    CookieService,
  ],
};

function getConfig(): AppConfigInterface {
  let appConfig: AppConfigInterface;

  switch (environment.type) {
    case 'DEV':
      appConfig = devConfig;
      break;
    case 'DEVSERVER':
      appConfig = devserverConfig;
      break;
    case 'STAGE':
      appConfig = stageConfig;
      break;
    case 'TEST':
      appConfig = testConfig;
      break;
    case 'UAT':
      appConfig = uatConfig;
      break;
    case 'PROD':
      appConfig = productionConfig;
      break;
    default:
      throw new Error(`Nieznany typ środowiska: ${environment.type}`);
  }

  return appConfig;
}
